'use client';
import React, { useEffect, useState } from 'react';

import { useProvincesDealershipsFilter } from '@/hooks/used-cars/provinces-dealerships-filter.hook';

import { Locations } from '../../filters/locations/locations';
import { SearchResultSelect } from '../search-result-select/search-result-select';
import { SearchResultsActionWrapper } from '../search-results-action-wrapper/search-results-action-wrapper';

export const LocationSelect: React.FC = () => {
  const selectedAllText = 'All locations';
  const [isVisible, setIsVisible] = useState(false);
  const [selectLabel, setSelectLabel] = useState(selectedAllText);
  const { provincesDealershipsSelectedFilters, selectedLocationsNumberInfo } =
    useProvincesDealershipsFilter();

  useEffect(() => {
    const { isOneSelected, isMultipleSelected, isAllSelected, isZeroSelected } =
      selectedLocationsNumberInfo;

    if (isOneSelected)
      setSelectLabel(provincesDealershipsSelectedFilters[0]?.fullName || '');
    else if (isMultipleSelected) setSelectLabel('Multiple');
    else if (isAllSelected) setSelectLabel(selectedAllText);
    else if (isZeroSelected) setSelectLabel(selectedAllText);
  }, [selectedLocationsNumberInfo]);

  return (
    <SearchResultsActionWrapper label="">
      <SearchResultSelect
        content={<Locations />}
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        contentProps={true}
      >
        {selectLabel}
      </SearchResultSelect>
    </SearchResultsActionWrapper>
  );
};
